import In2CLCMissionPage from "./In2CLCMissionPage";

export default In2CLCMissionPage;
